import { Controller } from "@hotwired/stimulus"

// Calcula la comisión de retiro en tiempo real: COP flat + tasa porcentual.
// Fórmula: comisión = flatCents + round(amountCents * rate)
// Recibirás = amountCents - comisión
export default class extends Controller {
  static targets = ["amountInput", "grossPreview", "commissionPreview", "netPreview"]
  static values = {
    flatCents: { type: Number, default: 300000 },  // COP 3.000 en centavos
    rate:      { type: Number, default: 0.005 }    // 0,5%
  }

  recalculate() {
    const amountCents = (parseInt(this.amountInputTarget.value) || 0) * 100
    const commissionCents = this.flatCentsValue + Math.round(amountCents * this.rateValue)
    const totalCents = amountCents + commissionCents

    if (this.hasGrossPreviewTarget) {
      this.grossPreviewTarget.textContent = this.formatCop(amountCents)
    }
    if (this.hasCommissionPreviewTarget) {
      this.commissionPreviewTarget.textContent = this.formatCop(commissionCents)
    }
    if (this.hasNetPreviewTarget) {
      this.netPreviewTarget.textContent = this.formatCop(totalCents)
    }
  }

  formatCop(cents) {
    const pesos = Math.floor(cents / 100)
    return `$${pesos.toLocaleString("es-CO")}`
  }
}
